import { render } from "./ExportarPlantadores.vue?vue&type=template&id=26867b8a"
import script from "./ExportarPlantadores.vue?vue&type=script&lang=js"
export * from "./ExportarPlantadores.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Workspace\\SalvandoArvores\\Codes\\salvando-arvores-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__